<div class="row px-10 pt-10 pb-3">
	<h3 class="col-12 fw-bold mb-3" translate>my_companies_header_navbar</h3>
	<div class="col-12 d-flex my-2 justify-content-between">
		<div class="d-flex align-items-center position-relative me-4 w-100">
			<app-keenicon name="magnifier" class="fs-3 position-absolute text-muted ms-3"></app-keenicon>
			<input
				type="text"
				class="form-control form-control-solid form-control-sm w-100 ps-10 p-2"
				[(ngModel)]="search"
				(input)="onSearchInput()"
				placeholder="{{ 'companies_search' | translate }}"
			/>
		</div>
		<button type="button" class="btn btn-primary d-flex align-items-center px-4 py-3" (click)="openCreateCompany($event)">
			<app-keenicon name="plus-circle" class="fs-3 text-white me-3"></app-keenicon>
			<span class="text-white font-size-sm" translate>add_company_header_navbar</span>
		</button>
	</div>
</div>

@if (companies$ | async) {
	<div class="px-10 pb-10">
		@for (company of companies$ | async; track company) {
			<div
				class="border-0 card p-4 mt-2 cursor-pointer animation pay-hover-company-opacity-100"
				[ngClass]="{
					'opacity-100': selectedCompany?.uuid === company.uuid,
					'opacity-50': selectedCompany?.uuid !== company.uuid,
				}"
				(click)="setActiveCompany(company)"
				(keydown.enter)="setActiveCompany(company)"
				tabindex="0"
			>
				<div class="d-flex align-items-center">
					@if (company.companyLogo?.file?.path) {
						<div class="symbol symbol-50px me-5">
							<span class="symbol-label">
								<img [src]="company.companyLogo?.file?.path" class="h-50px w-50px align-self-center pay-obj-fit p-2" alt="Company Logo" />
							</span>
						</div>
					} @else {
						<div class="symbol symbol-50px w-50px bg-light me-3">
							<img src="../../../../../../../customization/assets/spotside-pay-ico.svg" alt="" class="h-50px w-50px align-self-center pay-obj-fit p-2" />
						</div>
					}
					<div class="d-flex align-items-center justify-content-between w-100">
						<div class="me-2">
							<span class="text-gray-800 text-hover-primary fs-6 fw-bolder">{{ company.name }}</span>
							<span class="text-muted fw-bold d-block fs-7">{{ company.legalName }}</span>
						</div>
						@if (company.uuid) {
							<button
								type="button"
								class="btn btn-icon btn-icon-primary btn-bg-light btn-active-light-danger btn-active-color-danger ms-2"
								[ngClass]="{
									'opacity-100': selectedCompany?.uuid === company.uuid,
									'opacity-50': selectedCompany?.uuid !== company.uuid,
								}"
								(click)="deleteCompany(company.name, company.uuid)"
							>
								<app-keenicon name="trash" class="fs-3 text-danger text-hover-danger"></app-keenicon>
							</button>
						}
					</div>
				</div>
			</div>
		}
	</div>
}
